import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

export const linkStyle = {
  display: 'inline-block',
  fontWeight: 'bold',
  fontSize: '0.833rem',
  verticalAlign: 'middle',
}

const TranslateToggle = ({ label, link }) => {
  if (!label) return null
  return (
    <Link
      to={link}
      style={{
        ...linkStyle,
        margin: '0 .75rem',
      }}
    >
      {label}
    </Link>
  )
}

export const localeProps = PropTypes.oneOf(['/', 'en-ca', 'en-us', 'fr-ca'])

TranslateToggle.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string,
}

TranslateToggle.defaultProps = {
  link: '/',
}

export default TranslateToggle
